import { useParams } from "react-router-dom";
import { useUserData } from "../contexts/UserContext";
import { LogSessionProvider } from "../contexts/LogSessionContext";
import LogSessionWrapper from "../components/LogSessionWrapper";
import { useNavigate } from "react-router-dom";

export default function SurveyStart() {
  const { id } = useParams();
  const { user, getPerson } = useUserData();
  const navigate = useNavigate();

  if (!id) {
    return <div className="p-8 text-center text-red-600">Invalid person ID.</div>;
  }

  const person = getPerson(id);
  if (!person) {
    return <div className="p-8 text-center text-red-600">No person found for ID: {id}</div>;
  }

  if (!user) {
    return (
      <div className="p-8 text-center text-red-600">
        You must be signed in to start a survey.
      </div>
    );
  }
  
  return (
    <LogSessionProvider mode="survey" person={person} user={user}>
      <LogSessionWrapper />
    </LogSessionProvider>
  );
}
